import React, { FC, Fragment } from 'react';

import { FormattedMessage } from 'react-intl';

import { CoreUtils, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';

import { Divider, Situation } from './styles';

export enum DividerSide {
    left,
    right,
}

type Props = {
    descriptions?: Array<ShortCodeEnums.SituationCode>;
    timeRemaining?: string;
    dividerSide?: DividerSide;
    hideDanglingDivider?: boolean;
    showTime?: boolean;
};

const TeamSituation: FC<Props> = ({
    descriptions,
    timeRemaining,
    dividerSide = DividerSide.left,
    hideDanglingDivider = false,
    showTime = true,
}) =>
    descriptions?.map((situationDescription, idx) => {
        const hideDivider = idx === descriptions.length - 1 && hideDanglingDivider;

        return (
            <Fragment key={idx}>
                {dividerSide === DividerSide.left && !hideDivider && <Divider />}
                <Situation>
                    {situationDescription === ShortCodeEnums.SituationCode.powerPlay && timeRemaining && showTime ? (
                        <FormattedMessage
                            {...CommonMessages.misc.situationDescriptionWithTime}
                            values={{
                                situation: (
                                    <CoreUtils.SafeFormattedMessage
                                        message={
                                            CommonMessages.gameSituationDescriptions.abbreviations[situationDescription]
                                        }
                                    />
                                ),
                                situationTimeRemaining: timeRemaining,
                            }}
                        />
                    ) : (
                        <CoreUtils.SafeFormattedMessage
                            message={CommonMessages.gameSituationDescriptions.abbreviations[situationDescription]}
                        />
                    )}
                </Situation>
                {dividerSide === DividerSide.right && !hideDivider && <Divider />}
            </Fragment>
        );
    });

export default TeamSituation;
